import {
  DataList as ChakraDataList,
  DataListRootProps,
  DataListItemLabelProps,
  DataListItemValueProps,
} from '@chakra-ui/react'
import {ReactNode} from 'react'

export interface DataListItem {
  label: string
  value: ReactNode
  key?: string
}

export interface DataListProps extends DataListRootProps {
  items: DataListItem[]
  itemLabelProps?: DataListItemLabelProps
  itemValueProps?: DataListItemValueProps
}

export function DataList({items, itemLabelProps, itemValueProps, ...props}: DataListProps) {
  return (
    <ChakraDataList.Root orientation="horizontal" {...props}>
      {items.map((item, index) => (
        <ChakraDataList.Item
          key={item.key || item.label}
          borderColor="border"
          borderBottomWidth={index !== items.length - 1 ? '1px' : undefined}
          paddingBottom={index !== items.length - 1 ? '1' : undefined}
        >
          <ChakraDataList.ItemLabel minWidth="40" {...itemLabelProps}>
            {item.label}
          </ChakraDataList.ItemLabel>
          <ChakraDataList.ItemValue color="fg.muted" wordBreak="break-all" {...itemValueProps}>
            {item.value || '-'}
          </ChakraDataList.ItemValue>
        </ChakraDataList.Item>
      ))}
    </ChakraDataList.Root>
  )
}
